import { KoobAuthRedirect } from '@koob/ui';

const AuthRedirect = () => {
  return <KoobAuthRedirect />;
};

export default AuthRedirect;
